import React, { FC, memo } from 'react';
import { Autocomplete } from '@material-ui/lab';
import { TextField } from '@material-ui/core';

interface Props {
  value: string | null;
  onChange: (value: string | null) => void;
}

const taxCertificateOptions = ['for 2307', 'N/A'];

const Component: FC<Props> = ({  onChange, value }) => {
  
  return (
    <Autocomplete
      id="tax-certificate-list-dropdown"
      options={taxCertificateOptions}
      value={value}
      onChange={(event, newValue) => {
        onChange(newValue);
      }}
      fullWidth
      getOptionLabel={(option) => option}
      renderInput={(params) => (
        <TextField {...params} label="For Tax Certificate" variant="outlined" />
      )}
    />
  );
};

export const TaxCertificateOptionsDropdown = memo(Component);
